import { Controller } from "stimulus";

const SIDEBAR_SCROLL_KEY = "staffScheduleSidebarScroll";
const DETAIL_SCROLL_KEY = "staffScheduleDetailScroll";

export default class extends Controller {
  static targets = [
    "searchInput",
    "facilitatorRow",
    "filterEmpty",
    "visibleCount",
    "sidebarList",
    "detailPanel",
  ];

  connect() {
    this.beforeVisitHandler = this.saveScrollPositions.bind(this);
    document.addEventListener("turbolinks:before-visit", this.beforeVisitHandler);
    document.addEventListener("turbolinks:before-cache", this.beforeVisitHandler);

    this.filterRows();
    this.restoreScrollPositions();
  }

  disconnect() {
    document.removeEventListener("turbolinks:before-visit", this.beforeVisitHandler);
    document.removeEventListener("turbolinks:before-cache", this.beforeVisitHandler);
  }

  filterRows() {
    const query = this.hasSearchInputTarget
      ? this.searchInputTarget.value.trim().toLowerCase()
      : "";
    let visibleCount = 0;

    this.facilitatorRowTargets.forEach((row) => {
      const haystack = row.dataset.searchText || "";
      const visible = !query || haystack.includes(query);

      row.classList.toggle("hidden", !visible);
      if (visible) visibleCount += 1;
    });

    if (this.hasFilterEmptyTarget) {
      this.filterEmptyTarget.classList.toggle("hidden", visibleCount > 0);
    }

    if (this.hasVisibleCountTarget) {
      this.visibleCountTarget.textContent = String(visibleCount);
    }
  }

  searchChanged() {
    this.filterRows();
  }

  saveScrollPositions() {
    if (this.hasSidebarListTarget) {
      sessionStorage.setItem(
        SIDEBAR_SCROLL_KEY,
        String(this.sidebarListTarget.scrollTop)
      );
    }

    if (this.hasDetailPanelTarget) {
      sessionStorage.setItem(
        DETAIL_SCROLL_KEY,
        String(this.detailPanelTarget.scrollTop)
      );
    }
  }

  restoreScrollPositions() {
    if (this.hasSidebarListTarget) {
      const savedSidebar = sessionStorage.getItem(SIDEBAR_SCROLL_KEY);
      if (savedSidebar !== null) {
        this.sidebarListTarget.scrollTop = parseInt(savedSidebar, 10) || 0;
      }
    }

    if (this.hasDetailPanelTarget) {
      const switchingFacilitator = sessionStorage.getItem("staffScheduleSwitch") === "true";
      sessionStorage.removeItem("staffScheduleSwitch");

      if (switchingFacilitator) {
        this.detailPanelTarget.scrollTop = 0;
        sessionStorage.removeItem(DETAIL_SCROLL_KEY);
      } else {
        const savedDetail = sessionStorage.getItem(DETAIL_SCROLL_KEY);
        if (savedDetail !== null) {
          this.detailPanelTarget.scrollTop = parseInt(savedDetail, 10) || 0;
        }
      }
    }
  }

  facilitatorSelected() {
    sessionStorage.setItem("staffScheduleSwitch", "true");
    this.saveScrollPositions();
  }
}
